export const toggleHowItWorksListerDialog =
  '[HOW IT WORKS] TOGGLE LISTER DIALOG'
export const toggleHowItWorksMoverDialog = '[HOW IT WORKS] TOGGLE MOVER DIALOG'
